import { FC } from 'react';

const Empanelment: FC = () => {
  return (
    <section className="empanelment">
      <div className="empanelment__container ">
        <div className="empanelment__header">
          <h2>
            QuantMan is officially<span> Accredited!</span>
          </h2>
        </div>
        <div className="empanelment__content">
          <div className="empanelment__card">
            <img src="empanelment-1.svg" alt="empanelment1" />
            <h3 className="d-lg-block d-md-block d-none">National Stock Exchange </h3>
            <h3 className="d-lg-none d-md-none d-block">NSE </h3>
          </div>
          <div className="empanelment__card">
            <img src="empanelment-2.svg" alt="empanelment2" />
            <h3>ISO / IEC 27001:2022</h3>
          </div>
          <div className="empanelment__card">
            <img src="empanelment-3.svg" alt="empanelment3" />
            <h3 className="d-lg-block d-md-block d-none">Bombay Stock Exchange </h3>
            <h3 className="d-lg-none d-md-none d-block">BSE</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Empanelment;
